import React from "react";
import TextHero from "../../COMPONENTS/TEXT_HERO";
import ContactBlock from "../../COMPONENTS/CONTACT_BLOCK";
import JobApplicationForm from "../../COMPONENTS/FORM/JOB_APPLICATION";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

const JobPage = () => {
  useDocumentMeta({
    title: "Careers | KUR Research",
    description: "Apply to join KUR Research, an integrated clinical research site network.",
    path: "/job-application",
  });

  return (
    <>
      <TextHero
        id="careers-hero-title"
        title={
          <>
            Build your career <em>with KUR.</em>
          </>
        }
        lead="To give our employees unlimited growth potential and a company they can be proud of."
      />
      <ContactBlock
        id="apply"
        eyebrow="Job application"
        title="Apply to KUR Research."
        lead="Share your details and resume, and our team will be in touch about current opportunities."
        points={["PDF resume, up to 8 MB", "Every application is reviewed by our team"]}
      >
        <JobApplicationForm />
      </ContactBlock>
    </>
  );
};

export default JobPage;
